module.exports = __webpack_public_path__ + "img/298_kr.bb603d68.png";